import React from "react";
import styles from "./result.module.css";
import {Page} from "../../components/page/page";
import {zodiacs} from "./result-data";
import findZodiacSign from "./sings";
import {useSelector} from "react-redux";
import { getPaywallPage } from "src/shared/utils/get-paywall-page";
import { removeLocalStorage, StorageKey } from "src/shared/utils/localStorages";


const ResultPage = () => {
  const state = useSelector((store) => store.witch);
  const zodiacSign = findZodiacSign(state.birthDate.day, state.birthDate.month);
  const zodiac = zodiacs.find((el) => el.sign === zodiacSign)

  const guestId = useSelector((store) => store.guestId);
  const paywallPage = getPaywallPage('witch')
  const resultLink = `https://zodiaq.vip/${paywallPage}?userId=${guestId}&source=witch`;

  const title = [
    "Scorpio",
    "Pisces",
    "Capricorn",
    "Virgo",
    "Aquarius",
    "Cancer",
  ].includes(zodiacSign)
    ? "Wow, you definitely have witch power!"
    : "Wow, you have a strong intuition and can emotionally connect with other people";

  const handleContinue = () => {
    removeLocalStorage(StorageKey.UserId);
  };
  
  return (
    <div className={styles.page}>
      <Page 
        title={title} 
        hideSteps="true" 
        btnText="See other insights about you" 
        nextPageLink={resultLink} 
        onContinue={handleContinue}>
        <div>
          <h3 className={styles.subtitle}>{zodiac?.name || ''}</h3>
          <p className={styles.text}>{zodiac?.description || ''}</p>
          <ul className={styles.list}>
            <li className={styles.item_list}><span>Traits: </span>{zodiac?.traits || ''}</li>
            <li className={styles.item_list}><span>Magical Strength: </span>{zodiac?.magicalStrength || ''}</li>
          </ul>
        </div>
      </Page>
    </div>
  );
} 

export { ResultPage };